import { scaleLinear, extent, select } from "d3"

export function fitToBB(node, margin=10) {
    const parent = node.nextSibling;
    const {x, y, width, height} = parent.getBBox()
    node.setAttribute("x", x - margin)
    node.setAttribute("y", y - margin)
    node.setAttribute("width", width + 2 * margin)
    node.setAttribute("height", height + 2 * margin)

    return {
        update() {
            const {x, y, width, height} = parent.getBBox()
            node.setAttribute("x", x - margin)
            node.setAttribute("y", y - margin)
            node.setAttribute("width", width + 2 * margin)
            node.setAttribute("height", height + 2 * margin)
        }
    }
}

export function wait(t) {
    return new Promise(res => setTimeout(res, t))
}

export function getScales(D, [rangeX, rangeY], keepAspectRatio = false, x_accessor = d => d[0], y_accessor = d => d[1]) {
    let [x_min, x_max] = extent(D, x_accessor);
    let [y_min, y_max] = extent(D, y_accessor);

    if (keepAspectRatio) {
        const x_span = x_max - x_min;
        const y_span = y_max - y_min;
        const o = Math.abs(x_span - y_span) / 2;
        if (x_span > y_span) {
            y_min -= o;
            y_max += o;
        } else {
            x_min -= o;
            x_max += o;
        }
    }

    return { 
        x: scaleLinear().domain([x_min, x_max]).range(rangeX), 
        y: scaleLinear().domain([y_min, y_max]).range(rangeY)
    }
}

export const TAU = Math.PI * 2;

